import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingService } from 'ng-devui';
import { catchError, throwError } from 'rxjs';
import {
  TableColumnConfig,
  TableColumnOption,
  TableColumnType,
  TableConfig,
} from 'src/app/modules/shared/components/table-pro/table.config';
import { HostDirective } from 'src/app/modules/shared/directives/host.directive';
import { WorkReportDocType } from 'src/app/modules/shared/models/form/work-report-doc-type.enum';
import {
  WorkReportStatus,
  WorkReportStatusColorMap,
} from 'src/app/modules/shared/models/form/work-report-status.enum';
import { JgPhysicalInspUnitFb } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-fb.model';
import { JgPhysicalInspUnitFx } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-fx.model';
import { JgPhysicalInspUnitItemBatchRequest } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-item-batch-request.model';
import { JgPhysicalInspUnitItemInfo } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-item-info.model';
import { JgPhysicalInspUnitSearchRequest } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-search-request.model';
import { JgPhysicalInspUnit } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit.model';
import {
  ProjectSectionUnitJgStatusColorMap,
  ProjectSectionUnitJgStatusMap,
} from 'src/app/modules/shared/models/jg/project-section-unit-jg-status.enum';
import { ProjectItemType } from 'src/app/modules/shared/models/project/project-item-type.enum';
import { ProjectSectionListRequest } from 'src/app/modules/shared/models/project/project-section-list-request.model';
import {
  ProjectSectionUnitStatusColorMap,
  ProjectSectionUnitStatusMap,
} from 'src/app/modules/shared/models/project/project-section-unit-status.enum';
import { ProjectSection } from 'src/app/modules/shared/models/project/project-section.model';
import { NzTreeNode } from 'src/app/modules/shared/models/tree-node.model';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { Page } from 'src/app/modules/shared/providers/request/page.type';
import { JgPhysicalInspUnitFbService } from 'src/app/modules/shared/services/jg-physical-insp-unit-fb.service';
import { JgPhysicalInspUnitFxService } from 'src/app/modules/shared/services/jg-physical-insp-unit-fx.service';
import { JgPhysicalInspUnitService } from 'src/app/modules/shared/services/jg-physical-insp-unit.service';
import { ProjectSectionService } from 'src/app/modules/shared/services/project-section.service';

@Component({
  selector: 'app-handover-insp-entity-check',
  templateUrl: './handover-insp-entity-check.component.html',
  styleUrls: ['./handover-insp-entity-check.component.scss'],
})
export class HandoverInspEntityCheckComponent {
  @ViewChild(HostDirective, { static: true }) hiddenHost!: HostDirective;
  @ViewChild('scroll') scroll?: ElementRef<any>;

  config?: TableConfig = new TableConfig();

  searchRequest: JgPhysicalInspUnitSearchRequest =
    new JgPhysicalInspUnitSearchRequest();

  pager = this.globalService.recoverPager();

  totalWidth = 0;
  scrollTop = 0;
  scrollIndex = 0;
  isOpen = true;

  recordList: JgPhysicalInspUnit[] = [];

  sectionList: ProjectSection[] = [];

  isLM = false;
  // isLJ = false;

  recordTable: JgPhysicalInspUnit[] = [];
  recordFakeTable: JgPhysicalInspUnit[] = [];

  sectionOrgMap: { [key: string]: TableColumnOption[] } = {};

  ProjectSectionUnitJgStatusMap = ProjectSectionUnitJgStatusMap;

  ProjectSectionUnitJgStatusColorMap = ProjectSectionUnitJgStatusColorMap;

  ProjectSectionUnitStatusMap = ProjectSectionUnitStatusMap;

  ProjectSectionUnitStatusColorMap = ProjectSectionUnitStatusColorMap;
  WorkReportStatusColorMap = WorkReportStatusColorMap;
  sectionId: number;
  jgSectionId: number;

  jgPhysicalInspUnitFbList: JgPhysicalInspUnitFb[] = [];

  jgPhysicalInspUnitFxList: JgPhysicalInspUnitFx[] = [];

  jgFbCascaderOptions: NzTreeNode[] = [];

  jgFbCascaderValue: any[] = [];

  fxItemId: number = 0;

  fxItem?: JgPhysicalInspUnitFx;

  currentTotal = 0;

  unitConf: JgPhysicalInspUnitItemInfo[] = [];

  columnCheckMap: { [key: string]: boolean } = {};

  columnCheckCount: number[] = [];

  totalCheckedCount = 0;

  checkAll = false;

  mileStart = '';
  mileEnd = '';

  constructor(
    private router: Router,
    private loadingService: LoadingService,
    private activatedRoute: ActivatedRoute,
    private projectSectionService: ProjectSectionService,
    private jgPhysicalInspUnitService: JgPhysicalInspUnitService,
    private jgPhysicalInspUnitFbService: JgPhysicalInspUnitFbService,
    private jgPhysicalInspUnitFxService: JgPhysicalInspUnitFxService,
    private globalService: GlobalService,
  ) {
    this.jgSectionId = this.activatedRoute.snapshot.params['jgSectionId'];
    this.sectionId = this.activatedRoute.snapshot.params['sectionId'];
  }

  reset() {
    this.mileEnd = '';
    this.mileStart = '';
    this.recordTable = this.handleTable(
      JSON.parse(JSON.stringify(this.recordList)),
    );
    this.onScrollEnd();
  }

  asPrev(index: number) {
    if (index <= 0 || this.recordTable[index].asPrevDisabled) return;
    const prevRecord = this.recordTable[index - 1];
    const currentRow = this.recordTable[index];
    const origRow = this.findOrigRecord(currentRow);
    for (let j = 0; j < prevRecord.jgPhysicalInspUnitItems!.length; j++) {
      const checked = prevRecord.jgPhysicalInspUnitItems![j].checked;
      currentRow.jgPhysicalInspUnitItems![j].checked = checked;
      if (origRow) {
        origRow.jgPhysicalInspUnitItems![j].checked = checked;
      }
    }

    this.afterCheckChange();
  }

  onCheckAllChange() {
    // “全选”仅对当前过滤后可见的行（recordTable）生效，
    // 被里程过滤掉的 recordList 行保持原样；可见行的状态再通过 id 反写回 recordList。
    const idMap = this.buildRecordListIdMap();
    for (const row of this.recordTable) {
      row.checkAll = this.checkAll;
      for (const item of row.jgPhysicalInspUnitItems ?? []) {
        item.checked = this.checkAll;
      }
      const orig = row.id != null ? idMap.get(row.id) : undefined;
      if (orig) {
        orig.checkAll = this.checkAll;
        for (const item of orig.jgPhysicalInspUnitItems ?? []) {
          item.checked = this.checkAll;
        }
      }
    }
    this.afterCheckChange();
  }

  onColumnCheckChange(colIndex: number) {
    const checked =
      this.columnCheckMap[this.unitConf[colIndex].jgInspItemName!];
    const idMap = this.buildRecordListIdMap();
    for (const row of this.recordTable) {
      row.jgPhysicalInspUnitItems![colIndex].checked = checked;
      const orig = row.id != null ? idMap.get(row.id) : undefined;
      if (orig) {
        orig.jgPhysicalInspUnitItems![colIndex].checked = checked;
      }
    }
    this.afterCheckChange();
  }

  onItemUnitCheckAllChange(index: number) {
    const row = this.recordTable[index];
    const result = row.checkAll;
    for (const item of row.jgPhysicalInspUnitItems ?? []) {
      item.checked = result;
    }
    const orig = this.findOrigRecord(row);
    if (orig) {
      orig.checkAll = result;
      for (const item of orig.jgPhysicalInspUnitItems ?? []) {
        item.checked = result;
      }
    }
    this.afterCheckChange();
  }

  onUnitCheckChange(index: number, colIndex: number) {
    const row = this.recordTable[index];
    const orig = this.findOrigRecord(row);
    if (orig) {
      orig.jgPhysicalInspUnitItems![colIndex].checked =
        row.jgPhysicalInspUnitItems![colIndex].checked;
    }
    this.afterCheckChange();
  }

  /** recordTable 是 recordList 过滤后的深拷贝，按 id 反查原始记录 */
  private findOrigRecord(
    row: JgPhysicalInspUnit,
  ): JgPhysicalInspUnit | undefined {
    if (row.id == null) {
      return undefined;
    }
    return this.recordList.find((r) => r.id === row.id);
  }

  private buildRecordListIdMap(): Map<number, JgPhysicalInspUnit> {
    const map = new Map<number, JgPhysicalInspUnit>();
    for (const r of this.recordList) {
      if (r.id != null) {
        map.set(r.id, r);
      }
    }
    return map;
  }

  private afterCheckChange() {
    let checkAll = true;
    let columnCheckMap: { [key: string]: boolean } = {};
    const columnCheckCount = [];
    for (const unit of this.unitConf) {
      columnCheckMap[unit.jgInspItemName!] = true;
      columnCheckCount.push(0);
    }

    const idMap = this.buildRecordListIdMap();
    for (let i = 0; i < this.recordTable.length; i++) {
      const record = this.recordTable[i];
      let allCheck = true;
      for (let j = 0; j < record.jgPhysicalInspUnitItems!.length; j++) {
        const item = record.jgPhysicalInspUnitItems![j];
        if (!item.checked || item.jgRfiWorkFlowKey) {
          checkAll = false;
          columnCheckMap[item.jgInspItemName!] = false;
          allCheck = false;
        } else {
          columnCheckCount[j]++;
        }
        record.checkAll = allCheck;
        const orig = record.id != null ? idMap.get(record.id) : undefined;
        if (orig) {
          orig.checkAll = allCheck;
        }
      }
    }
    this.columnCheckCount = columnCheckCount;
    this.checkAll = checkAll;
    this.columnCheckMap = columnCheckMap;
    this.totalCheckedCount = this.columnCheckCount.reduce(
      (prev, curr) => prev + curr,
      0,
    );
  }

  ngOnInit(): void {
    this.getJgFb();
    this.getSectionList();
  }

  getSectionList() {
    this.projectSectionService
      .findAll<ProjectSectionListRequest>({
        projectId: this.globalService.projectId,
      })
      .subscribe((projectSections) => {
        this.sectionList = projectSections;
      });
  }

  getJgFb() {
    this.jgPhysicalInspUnitFbService
      .findAll({
        jgSectionId: this.jgSectionId,
        sectionId: this.sectionId,
        projectId: this.globalService.projectId,
      })
      .subscribe((res: JgPhysicalInspUnitFb[]) => {
        this.jgPhysicalInspUnitFbList = res.sort((a, b) => {
          if (a.dwCodeSort === b.dwCodeSort) {
            if (a.dwTypeNameSort === b.dwTypeNameSort) {
              return a.jgFbNameSort! - b.jgFbNameSort!;
            }
            return a.dwTypeNameSort! - b.dwTypeNameSort!;
          }
          return a.dwCodeSort! - b.dwCodeSort!;
        });
        this.jgFbCascaderOptions = this.buildJgInspUnitFbTree(res);
      });
  }

  private buildJgInspUnitFbTree(
    jgFbList: JgPhysicalInspUnitFb[],
  ): NzTreeNode[] {
    const nodes: NzTreeNode[] = [];
    if (jgFbList.length === 0) {
      return nodes;
    }
    let lastDw = '';
    for (const item of jgFbList) {
      if (lastDw !== item.dwCode) {
        nodes.push({
          label: item.dwCode! + ' ' + item.dwName!,
          value: item.dwCode! + '#' + item.dwName!,
          children: [
            {
              label: item.jgFbName!,
              value: `${item.dwCode!}#${item.dwName!}#${item.jgFbName!}#${item.jgSectionId}`,
              isLeaf: true,
            },
          ],
        });
      } else {
        nodes[nodes.length - 1].children!.push({
          label: item.jgFbName!,
          value: `${item.dwCode!}#${item.dwName!}#${item.jgFbName!}#${item.jgSectionId}`,
          isLeaf: true,
        });
      }
      lastDw = item.dwCode!;
    }

    return nodes;
  }

  onFbCascaderValueChange() {
    this.fxItem = undefined;
    this.fxItemId = 0;
    this.config = new TableConfig();
    this.recordList = [];
    this.recordTable = [];
    const value = this.jgFbCascaderValue[this.jgFbCascaderValue.length - 1];
    const [dwCode, dwName, jgFbName, jgSectionId] = value.split('#');
    this.jgPhysicalInspUnitFxService
      .findAll({
        projectId: this.globalService.projectId,
        jgSectionId,
        sectionId: this.sectionId,
        dwCode,
        jgFbName,
      })
      .subscribe((res: JgPhysicalInspUnitFx[]) => {
        this.jgPhysicalInspUnitFxList = res;
      });
  }

  onUnitFxItemChoose() {
    this.fxItem = this.jgPhysicalInspUnitFxList.find(
      (item) => item.id === this.fxItemId,
    );
    this.recordTable = [];

    this.isLM = false;
    if (
      this.fxItem!.dwCode!.indexOf('L') === 0 ||
      this.fxItem!.dwCode!.indexOf('J') === 0
    ) {
      this.isLM = true;
    }
    this.jgPhysicalInspUnitService
      .search(
        {
          projectId: this.globalService.projectId,
          jgSectionId: this.fxItem?.jgSectionId,
          sectionId: this.fxItem?.sectionId,
          dwCode: this.fxItem?.dwCode,
          jgFbName: this.fxItem?.jgFbName,
          jgFxName: this.fxItem?.jgFxName,
          jgFxProjectTypeCode: this.fxItem?.jgFxProjectTypeCode,
        },
        0,
        1,
      )
      .subscribe((res: Page<JgPhysicalInspUnit>) => {
        this.currentTotal = +res.totalElements;
        const conf = res.content[0].jgPhysicalInspUnitItems ?? [];
        this.initConfig(conf);
      });
  }

  getColor(status: string) {
    switch (status) {
      case WorkReportStatus.DRAFT:
        return '#000000';
      case WorkReportStatus.FINISH:
        return '#2b58cd';
      case WorkReportStatus.WAIT_SIGN:
      case WorkReportStatus.WAIT_SEAL:
        return '#A30014';
      case WorkReportStatus.REJECT_SIGN:
      case WorkReportStatus.REJECT_SEAL:
      case WorkReportStatus.CANCLE:
        return '#FF0000';
      default:
        return '#BDC3C7';
    }
  }

  initConfig(conf: JgPhysicalInspUnitItemInfo[]) {
    this.unitConf = conf;
    const defaultColumn: TableColumnConfig[] = [
      {
        name: '分部工程',
        key: 'fbName',
        type: TableColumnType.text,
        width: 120,
      },
      {
        name: '分部工程单元',
        key: 'subFbName',
        type: TableColumnType.text,
        width: 120,
      },
      {
        name: '分项工程单元',
        key: 'sectionName',
        type: TableColumnType.text,
        width: 140,
      },
      {
        name: '施工单位',
        key: 'constructionOrgName',
        type: TableColumnType.options,
        options: this.sectionOrgMap[`${this.searchRequest.sectionId}`],
        width: 70,
      },
    ];
    if (this.isLM) {
      defaultColumn.push({
        name: '段',
        key: 'code',
        type: TableColumnType.text,
        width: 40,
      });
      defaultColumn.push({
        name: '分段里程',
        key: 'mileage',
        type: TableColumnType.text,
        width: 100,
      });
    }

    defaultColumn.push({
      name: '施工资料',
      key: 'mark',
      type: TableColumnType.text,
      width: 70,
    });
    defaultColumn.push({
      name: '监理资料',
      key: 'mark',
      type: TableColumnType.text,
      width: 70,
    });
    defaultColumn.push({
      name: '备注',
      key: 'comment',
      type: TableColumnType.text,
      width: 120,
    });
    defaultColumn.push({
      name: '快捷操作',
      key: 'label',
      type: TableColumnType.text,
      width: 50,
    });
    defaultColumn.push({
      name: '检测项目全选↓',
      key: 'selectAll',
      type: TableColumnType.text,
      width: 80,
    });

    for (const item of conf) {
      defaultColumn.push({
        name: item.jgInspItemName!,
        key: `jgInspItem_${item.id}`,
        type: TableColumnType.text,
        width: 80,
      });
    }

    this.config = {
      hasIndex: true,
      columns: defaultColumn,
      headerSize: 12,
      bodySize: 13,
    };

    this.totalWidth = defaultColumn.reduce((acc, cur) => acc + cur.width, 56);

    this.searchRecord();
  }

  onScroll(event: any) {
    if (this.recordFakeTable.length > 0) {
      this.recordFakeTable = [];
    }
  }

  onScrollEnd($event?: any) {
    const startIndex = Math.floor(this.scroll?.nativeElement.scrollTop / 40);
    const viewportHeight =
      this.scroll?.nativeElement.clientHeight - (this.isOpen ? 120 : 80);
    let endIndex = Math.ceil(viewportHeight / 40) + startIndex;
    if (endIndex > this.recordList.length - 1) {
      endIndex = this.recordList.length - 1;
    }
    const offset = this.scroll?.nativeElement.scrollTop % 40;
    this.scrollTop = this.scroll?.nativeElement.scrollTop - offset;
    this.scrollIndex = startIndex;

    this.recordFakeTable = this.handleTable(
      JSON.parse(
        JSON.stringify(this.recordList.slice(startIndex, endIndex + 1)),
      ),
    );
  }

  private handleTable(recordTable: JgPhysicalInspUnit[]) {
    if (recordTable.length === 0) {
      return [];
    }
    console.log('recordTable');
    let index = recordTable.length - 1;
    while (index > 0) {
      if (recordTable[index].fbCode === recordTable[index - 1].fbCode) {
        recordTable[index].fbCode = '';
        recordTable[index].fbName = '';
        recordTable[index - 1].fbSpan = recordTable[index].fbSpan
          ? recordTable[index].fbSpan! + 1
          : 2;
        if (recordTable[index].subFbCode === recordTable[index - 1].subFbCode) {
          recordTable[index].subFbCode = '';
          recordTable[index].subFbName = '';
          recordTable[index - 1].subFbSpan = recordTable[index].subFbSpan
            ? recordTable[index].subFbSpan! + 1
            : 2;
          if (this.isLM) {
            if (
              recordTable[index].sectionCode ===
              recordTable[index - 1].sectionCode
            ) {
              recordTable[index].sectionCode = '';
              recordTable[index].sectionName = '';
              recordTable[index - 1].sectionSpan = recordTable[index]
                .sectionSpan
                ? recordTable[index].sectionSpan! + 1
                : 2;
            }
          }
        }
      }
      index--;
    }
    return recordTable;
  }

  sign(workFlowKey: string) {
    const query = window.location.href.split('?')[1] ?? '';
    const params = new URLSearchParams(query);
    if (location.href.indexOf('#/open/') > -1) {
      this.openInTab(
        `#/open/custom-form/sign/${workFlowKey!}?token=${params.get('token')}`,
      );
    } else {
      this.openInTab(`#/custom-form/sign/${workFlowKey!}`);
    }
  }

  private openInTab(url: string) {
    const target = window.open(url, '_blank');
    setTimeout(() => {
      target?.postMessage({
        type: 'redir',
        data: window.location.href,
      });
    }, 1000);
    // target?.postMessage('redir', window.location.href);
  }

  onLcSearch() {
    const filteredRecords = JgPhysicalInspUnit.filterRecordsByMile(
      JSON.parse(JSON.stringify(this.recordList)),
      this.mileStart,
      this.mileEnd,
    );
    this.recordTable = this.handleTable(filteredRecords);
    this.onScrollEnd();
  }

  searchRecord() {
    this.jgPhysicalInspUnitService
      .search<JgPhysicalInspUnitSearchRequest>(
        {
          projectId: this.globalService.projectId,
          jgSectionId: this.fxItem?.jgSectionId,
          sectionId: this.fxItem?.sectionId,
          dwCode: this.fxItem?.dwCode,
          jgFbName: this.fxItem?.jgFbName,
          jgFxName: this.fxItem?.jgFxName,
          jgFxProjectTypeCode: this.fxItem?.jgFxProjectTypeCode,
          sectionItemType: this.isLM
            ? ProjectItemType.SEGMENT
            : ProjectItemType.SECTION,
        },
        this.pager.pageIndex - 1,
        this.currentTotal,
      )
      .subscribe((data: Page<JgPhysicalInspUnit>) => {
        this.globalService.savePager(this.pager);
        if (!!data) {
          this.recordList = data.content ?? [];
          for (const item of this.recordList) {
            let reportCount = 0;
            for (const inspItem of item.jgPhysicalInspUnitItems ?? []) {
              if (!!inspItem.jgRfiWorkFlowKey) {
                reportCount++;
              }
            }
            item.asPrevDisabled = reportCount > 0;
            item.checkAllDisabled =
              reportCount === (item.jgPhysicalInspUnitItems?.length ?? 0);
          }
          this.initCheckMap();
          if (!this.isLM) {
            for (const item of this.recordList) {
              item.sectionCode = item.code;
              item.sectionName = item.name;
            }
          }
        }
        this.recordTable = this.handleTable(
          JSON.parse(JSON.stringify(this.recordList)),
        );
        this.pager.total = data.totalElements;
        this.onScrollEnd();
      });
  }

  private initCheckMap() {
    this.checkAll = false;
    for (const record of this.recordList) {
      for (const item of record.jgPhysicalInspUnitItems ?? []) {
        item.checked = false;
      }
    }
    const columnCheckMap: { [key: string]: boolean } = {};
    for (const item of this.unitConf) {
      columnCheckMap[item.jgInspItemName!] = false;
    }
    this.columnCheckMap = columnCheckMap;
  }

  editing: any = {};

  edit(key: string) {
    this.editing[key] = true;
    console.log(this.editing);
  }

  onBlur(id: number, comment: string) {
    this.editing = {};
    this.jgPhysicalInspUnitService
      .update({
        id,
        comment,
      })
      .subscribe(() => {
        this.searchRecord();
      });
  }

  cancel() {
    window.close();
  }

  confirm() {
    if (!this.fxItem) {
      return;
    }
    const loading = this.loadingService.open();
    this.jgPhysicalInspUnitService
      .batchInsp(this.buildReq())
      .pipe(
        catchError((err) => {
          loading.loadingInstance.close();
          return throwError(err);
        }),
      )
      .subscribe((res) => {
        loading.loadingInstance.close();
        for (const result of res) {
          if (!result.success) {
            continue;
          } else {
            this.sign(result.workFlowKey!);
            break;
          }
        }
        window.close();
      });
  }

  private buildReq(): JgPhysicalInspUnitItemBatchRequest {
    const req = new JgPhysicalInspUnitItemBatchRequest(
      this.fxItem,
      WorkReportDocType.DEFAULT,
    );
    const items: JgPhysicalInspUnitItemInfo[] = [];
    for (const record of this.recordList) {
      for (const item of record.jgPhysicalInspUnitItems ?? []) {
        if (item.checked && !item.jgRfiWorkFlowKey) {
          items.push(item);
        }
      }
    }
    req.itemInfos = items;
    return req;
  }
}
